import { Link } from "react-router-dom";

export default function HomeSubscribe() {
  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-[1280px] overflow-hidden rounded-lg bg-secondary-100">
        <div className="grid grid-cols-1 items-center gap-8 p-6 md:grid-cols-12 md:p-10">
          <div className="md:col-span-7">
            <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-secondary-700">
              <i className="ri-notification-3-line"></i> Daily Digest
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              把今天的瓜，整理好送到你手边
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-700">
              每天一封简短的瓜报，只挑真正值得看的三五条，附上时间线和背景，读完不用再翻半天评论区。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row md:col-span-5 md:justify-end">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line"></i> 订阅每日瓜报
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-secondary-500"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}